import React, { useState, useEffect } from 'react';
import { NotificationList } from './NotificationList';
import { useTranslation } from 'react-i18next';
import { useGetNotificationsQuery, useUpdateNotificationsMutation, useMarkNotificationsAsReadMutation } from 'store/api';
import GeneralList from './GeneralList';
import Loading from 'components/Loading';
import TabButton from 'components/TabButton';
import { api } from 'utils/axios';

const Notification = () => {
  const { t } = useTranslation();
  const [status, setStatus] = useState('invites');
  const [isChanged, setIsChanged] = useState(false);
  const [updateNotifications] = useUpdateNotificationsMutation();
  const [markNotificationsAsRead] = useMarkNotificationsAsReadMutation();
  const [isReplied, setIsReplied] = useState(false);

  const {
    data: notifications = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetNotificationsQuery(status, { refetchOnMountOrArgChange: !isChanged });

  const blockUser = (id, callback, toggleBlocked) => {
    api
      .post(process.env.REACT_APP_API + 'notification/permission/block/', { user: id })
      .then((response) => {
        toggleBlocked();
      })
      .finally(() => callback());
  };

  const unblockUser = (id, closeModal, toggleBlocked) => {
    api
      .post('notification/permission/allow/', { user: id })
      .then((response) => {
        toggleBlocked();
        closeModal();
      })
      .catch((error) => closeModal());
  };

  const replyNotification = async (invite_id, type) => {
    if (type !== 'denied' && type !== 'accepted') return;
    const response = await updateNotifications({ id: invite_id, response: type });
    setIsReplied(true);
    return response;
  };

  const changeSection = async (state) => {
    setStatus(state);
    setIsChanged(true);
    if (isReplied) {
      await refetch();
      setIsReplied(false);
    }
  };

  // Mark notifications as read when component mounts
  useEffect(() => {
    markNotificationsAsRead();
  }, [markNotificationsAsRead]);

  return (
    <>
      <div>
        <div className='options'>
          <div>
            <TabButton
              text={t('notification.invites')}
              onClick={() => changeSection('invites')}
              isActive={status === 'invites'}
              counter={notifications?.invites?.new}
            />
          </div>
          <div className='text-lg'>
            <TabButton
              text={t('notification.general')}
              onClick={() => changeSection('general')}
              isActive={status === 'general'}
              counter={notifications?.general?.new}
            />
          </div>
        </div>
        <div
          className={`w-full md:w-[720px] bg-neutral-silver-700  flex overflow-y-auto flex-col md:px-8 md:py-10 px-3 py-4 rounded-2xl ${
            (isLoading || isFetching) && 'items-center'
          }`}
        >
          {isLoading || isFetching ? (
            <Loading />
          ) : status === 'general' ? (
            <GeneralList data={notifications?.general?.notifications} />
          ) : (
            <NotificationList
              invites={notifications?.invites?.notifications}
              blockUser={blockUser}
              replyNotification={replyNotification}
              unblockUser={unblockUser}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Notification;
